export default __webpack_public_path__ + "static/media/contact.e95de7a9.jpg";